import './conversion-log-table.component.scss'
import {ConversionLogFilter} from "../../model/ConversionLogFilter";
import {Page, Pageable} from "../../../utils/models/Page";
import {ConversionReportLog} from "../../model/ConversionReportLog";
import {IPromise, IScope} from "angular";
import {LoaderStatusValue} from "../../../loader/service/loaderStatus";
import {ConversionLogService} from "../../service/ConversionLogService";
import {ConversionLogServiceName} from "../../../utils/names/serviceNames";
import {ConversionLogsSelectionOptions} from "../../model/ConversionLogsSelectionOptions";
import {PrincipalUtil} from "../../../utils/PrincipalUtil";
import {UserGranredAuthorityName} from "../../../router/const/AllPermitions";
import {ConversionLogControlsOptions} from "../../model/ConversionLogControlsOptions";
import {getColumnsConfig} from "../../constants/conversions-table-column-configurations";

const DEFAULT_PAGE_SIZE = 10;


export class ConversionLogTable {

    static instance = {
        template: require('./conversion-log-table.component.html'),
        controller: [
            '$scope',
            '$location',
            'LoaderStatusValue',
            ConversionLogServiceName,
            ConversionLogTable
        ],
        controllerAs: '$ctrl',
        bindings: {
            filter: '=',
            onCustomerProfileClick: '<'
        }
    }


    private filter: ConversionLogFilter;
    private pagingConfig: Pageable;
    private logs: ConversionReportLog[];
    private selectionOptions: ConversionLogsSelectionOptions;
    private conversionLogControlsOptions: ConversionLogControlsOptions;
    private onCustomerProfileClick: () => IPromise<any>;
    private columnsConfig = getColumnsConfig(window.innerWidth);

    constructor(private $scope: IScope,
                private $location: ng.ILocationService,
                private loaderService: LoaderStatusValue,
                private conversionLogService: ConversionLogService) {
    }

    $onInit() {
        this.initSelectionOptions();
        this.initControlsOptions();
        this.initFilter();
        this.initPagingConfig();
        this.initOnCustomerProfileClick();
        //I am not sure this is a good idea...
        this.$scope.$watch('$ctrl.selectionOptions.selectedIds.length', this.handleSelectionSizeChange);
    }

    private initOnCustomerProfileClick() {
        if (this.onCustomerProfileClick == null) {
            this.onCustomerProfileClick = () => Promise.resolve();
        }
    }

    private initPagingConfig() {
        this.pagingConfig = {
            fetchPage: this.fetchLogs,
            page: 1,
            pageSize: DEFAULT_PAGE_SIZE,
            totalElements: 0
        };
    }

    private initFilter() {
        this.filter = this.filter || {
            branchNames: [],
            brandName: [],
            conversionTypes: [],
            campaignTypes: [],
            calculatorNames: []
        };
    }

    private initSelectionOptions() {
        this.selectionOptions = new ConversionLogsSelectionOptions();
        this.selectionOptions.filter = this.filter;
    }

    private initControlsOptions() {
        this.conversionLogControlsOptions = {
            allowCsvExport: false
        }
        PrincipalUtil.hasAuthorityPromise(UserGranredAuthorityName.CSV_EXPORT)
            .then(toggle => this.conversionLogControlsOptions.allowCsvExport = toggle);
    }

    private onFilterValueChange = (filter: ConversionLogFilter) => {
        this.filter.startDate = filter.startDate;
        this.filter.endDate = filter.endDate;
    };

    private onFilterSubmit = (filter: ConversionLogFilter) => {
        this.fetchLogs();
    }

    private fetchLogs = (): IPromise<void> => {
        this.loaderService.on();
        return this.conversionLogService.fetchConversionsLog(this.filter, this.pagingConfig.page - 1, this.pagingConfig.pageSize)
            .then(page => this.handlePageUpdate(page))
            .then(() => this.loaderService.off());
    };

    private handlePageUpdate(page: Page<ConversionReportLog>) {
        this.pagingConfig.page = page.number + 1;
        this.pagingConfig.pageSize = page.size;
        this.pagingConfig.totalElements = page.totalElements;
        this.logs = page.content;
    }

    public navigateToCustomerPage(customerId: number) {
        this.onCustomerProfileClick()
            .then(() => this.$location.url(`/contact_profile/${customerId}`));
    }

    handleSelectionSizeChange = (size: number) => {
        this.selectionOptions.allSelected = size === this.pagingConfig.totalElements;
    };

    getTableClass = () => {
        if (!this.conversionLogControlsOptions.allowCsvExport) {
            return 'conversion-log-table-readonly';
        }
    }

    shouldDisplay = (columnName: string): boolean => {
        return this.columnsConfig.has(columnName);
    }


}